// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"774780d1","322":"90f35022","453":"1b1ee538"}[chunkId] + ".chunk.js";
};